<template>
  <div :class="expandSearch ? 'mr-2':'mr-n2'">
    <div class="d-flex justify-space-between">
      <span
        v-if="!expandSearch"
        class="align-self-center"
        @click="expandSearch=!expandSearch"
      >
        {{ this.label }}
      </span>
      <span
        :class="expandSearch ? 'grow':''"
        :style="{width:expandSearch ? searchWidth :'50px'}"
      >
        <v-text-field
          v-bind="$attrs"
          v-on="$listeners"
          :outlined="outlined"
          :placeholder="expandSearch ? placeholder:''"
          :style="{width:expandSearch ? searchWidth :'50px'}"
          :clearable="expandSearch ? true : false"
          class="neutralSearch"
          :hide-details="hideDetails"
          :dense="dense"
          v-model="searchContent"
          :class="expandSearch ? 'expandSearch':'shrinkSearch hideBorder'"
          prepend-inner-icon="search"
          clear-icon="mdi-close-circle"
          @click:clear="$emit('clearSearch')"
          @keyup="$emit('keyupEvent',searchContent)"
          @keypress.enter="!globalSearch ? $eventHub.$emit('Search',searchContent) : searchGlobal()"
          @click:prepend-inner="expandSearch=!expandSearch"
        />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Search',
  props: {
    outlined: {
      type: Boolean,
      default: true   // override the default value 'false' in v-text-field
    },
    hideDetails: {
      type: [Boolean, String],
      default: true   // override the default value 'undefined' in v-text-field
    },
    dense: {
      type: Boolean,
      default: true   // override the default value 'false' in v-text-field
    },
    searchWidth: {
      type: String,
      default: '300px'
    },
    globalSearch: Boolean,
    label: {
      type: String,
      default: 'Search'
    },
    searchUrl: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Search'
    }
  },
  methods: {
    searchGlobal() {
      let url = this.searchUrl + this.searchContent;
      window.open(url, '_blank');
    }
  },
  data: function () {
    return {
      searchString: '',
      expandSearch: false,
      searchContent: ''
    }
  },
  watch: {
    expandSearch: function (oldVal, newVal) {
      if (oldVal !== newVal) {
        this.$emit('searchClick', this.expandSearch);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';

.neutralSearch {
  width: 50px;
}

.expandSearch {
  min-width: 100px;
  max-width: 100%;
  transition: width 0.5s;
}

.shrinkSearch {
  z-index: 1;
  width: 50px;
  transition: width 0.5s;
}

::v-deep .hideBorder.v-text-field--outlined fieldset {
  border: none !important;
}
</style>
